module.exports = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    baseMediaUrl: process.env.REACT_APP_MEDIA_CDN_BASE_DOMAIN,
    listStory: 'getAppStoryList',
};